<template>
  <div @click="$emit('button', conversation.id)">
    <ul
      :class="['notification-list chat-message', { selected: selected }]"
      @click.prevent="openChat"
    >
      <li>
        <div
          class="item-box"
          :class="[
            { 'item-unavailable': getItemAvailability(conversation) },
            itemBoxClass,
          ]"
          v-if="isItemChat"
        >
          <img :src="getItemImagePath(conversation)" alt="Item" />
        </div>
        <div v-else class="group-image">
          <img :src="getGroupImagePath(conversation)" alt="Group" />
          <md-icon
            v-if="conversation.privacy === groupPrivate"
            class="md-icon md-primary"
            >security
          </md-icon>
        </div>
        <div class="notification-event">
          <div class="table-row">
            <a href="#" class="conversation-title text">{{
              conversationTitle
            }}</a>
            <span class="notification-date">
              <time class="text entry-date">{{
                getLastMsgTimeStamp(allMessages) | date
              }}</time>
            </span>
          </div>
          <div class="table-row">
            <span class="text chat-message-item text-break" v-if="displayDraft">
              <div class="div-draft">
                <p class="mr-1 m-0 draft">Draft:</p>
                <p class="m-0 draft-content">{{ draft }}</p>
              </div>
            </span>
            <span
              class="text chat-message-item text-break"
              v-else-if="lastMsg.type === 'FILE'"
            >
              <img
                :src="getChatImage(lastMsg.msg)"
                id="chat-message"
                alt="Image"
                class="pt-1"
              />
              <p class="m-0">{{ lastMsg.msg | fileName }}</p>
            </span>
            <p class="text chat-message-item text-break" v-else>
              {{ lastMsg.msg }}
            </p>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import UserHelperVue from "@/mixins/UserHelper.vue";
import ChatHelperVue from "@/mixins/ChatHelper.vue";
import ItemHelperVue from "@/mixins/ItemHelper.vue";
import GroupHelperVue from "@/mixins/GroupHelper.vue";
import groupPrivacy from "@/enum/group-privacy";
export default {
  name: "ChatItemListUserSelected",
  props: ["conversation", "newMsg", "selected"],
  mixins: [UserHelperVue, ChatHelperVue, ItemHelperVue, GroupHelperVue],
  data() {
    return {
      draft: null,
    };
  },
  computed: {
    groupPrivate() {
      return groupPrivacy.PRIVATE;
    },
    lastMsg() {
      const length = this.allMessages.length;
      return this.allMessages[length - 1];
    },
    displayDraft() {
      return !!(this.draft !== "" && this.draft !== null && !this.selected);
    },
    conversationTitle() {
      return this.conversation.name ?? this.conversation.title;
    },
    isItemChat() {
      return this.conversation.title ? true : false;
    },
    allMessages() {
      return this.conversation.messages;
    },
    itemBoxClass() {
      return this.conversation.type === 3 || this.conversation.type === 1
        ? "item-box-request"
        : "item-box-offer";
    },
  },
  methods: {
    saveDraft(value) {
      this.draft = value;
    },
    openChat() {
      if (window.innerWidth <= 1023) {
        if (
          this.message.id !== this.chatMessages.id &&
          Object.keys(this.chatMessages).length > 0
        ) {
          this.$emit("popupWindowClose");
          setTimeout(() => {
            this.setPopupChat({
              isOpen: true,
              chatMsgs: this.conversation,
            });
            this.$emit("popupWindowOpen");
          }, 300);
        } else {
          this.setPopupChat({
            isOpen: true,
            chatMsgs: this.conversation,
          });
          this.$emit("popupWindowOpen");
        }
      }
    },
  },
};
</script>

<style scoped>
#chat-message {
  max-width: 100px;
  max-height: 50px;
}
.pointer {
  cursor: pointer;
}
</style>

<style lang="scss">
.icon-status {
  margin-right: unset !important;
  margin-left: 8px;
  vertical-align: text-top;
}
</style>

<style lang="scss" scoped>
.notification-list {
  cursor: pointer;

  li:hover {
    // background-color: #f1f1f1;
    background-color: rgba($color: #a6abc7, $alpha: 0.1);
    transition: background-color ease-out 120ms;
  }

  &.selected {
    background-color: rgba($color: #3f4257, $alpha: 0.1);
  }
}
.notification-event {
  max-width: unset;
  width: 100% !important;
  display: table;
  margin-left: 0.5rem;
}
.table-row {
  display: flex;
  justify-content: space-between;
}
.notification-list li {
  padding: 10px 15px 10px 15px;
  width: 100%;
  border-bottom: unset;
  display: table;
}
.item-box {
  width: 47px;
  height: 47px;
  display: table-cell;
  padding: 4px;
}
.item-box-offer {
  border: 1px solid $offer;
}
.item-box-request {
  border: 1px solid $request;
}
.group-image {
  width: 47px;
  height: 47px;
  display: table-cell;
}
.text {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 1.25px;
  color: $black !important;
}
.conversation-title {
  opacity: 0.8;
  float: none;
}
.chat-message-item {
  opacity: 0.4;
  overflow: hidden;
  width: 230px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  margin-bottom: unset;
  margin-top: 5px;
}
.notification-date {
  display: table-cell;
  text-align: right;
}
.entry-date {
  font-size: 10px;
  opacity: 0.6;
}
.div-draft {
  overflow: hidden;
  display: inline-flex;
  flex-wrap: wrap;

  p {
    font-size: 12px;
  }
}
.draft {
  float: left;
  color: $danger;
}
.draft-content {
  float: right;
}
.group-image .md-icon {
  transform: translatex(57px) translatey(-39px);
  position: absolute;
}
.d-flex .chat-box .remove-padding {
  transform: translatex(0px) translatey(0px);
}
.chat-box li .md-theme-swampum-primary {
  top: 75px;
  left: -16px;
  background-color: $white;
  border-radius: 100%;
}
</style>
